import styled from 'styled-components';

/**
 * Mesma linguagem visual do `InputSelect`, com uma diferença: a opção aqui tem
 * duas linhas (nome e e-mail), então o menu não pode herdar a altura fixa do
 * campo — só o controle fechado mantém `--input-height`.
 */
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .react-select__control {
    height: var(--input-height);
    border: 1px solid var(--primary-color);
    border-radius: 8px;
  }

  .react-select__control--is-focused {
    box-shadow: none;
    border: 1px solid var(--accent-color) !important;
  }

  .react-select__value-container {
    height: var(--input-height);
    padding-left: 15px;
  }

  .react-select__placeholder,
  .react-select__single-value {
    margin-top: 5px;
    margin-left: 8px;
  }

  .react-select__input {
    margin-left: 8px;
  }

  .react-select__menu {
    z-index: 2;
  }

  :focus-within {
    > label {
      color: var(--accent-color);
    }
  }

  .error {
    color: #f00;
    margin-top: 5px;
    font-weight: 500;
  }
`;

const Label = styled.label`
  background-color: white;
  transform: translateY(10px);
  align-self: flex-start;
  padding: 0 10px 0 8px;
  margin-left: 10px;
  color: var(--primary-color);
  font-weight: 500;
  z-index: 1;
`;

const OptionName = styled.span`
  display: block;
`;

const OptionEmail = styled.span`
  display: block;
  font-size: 1.3rem;
  color: #9a9a9a;
`;

export { Container, Label, OptionName, OptionEmail };
